
import { useNavigate } from 'react-router-dom';
import BottomNav from '../../components/base/BottomNav';

export default function Home() {
  const navigate = useNavigate();

  const stats = [
    { value: '2.5K+', label: 'Estudantes', icon: 'ri-user-line', color: 'from-blue-500 to-blue-600' },
    { value: '8.7K+', label: 'Mentorias', icon: 'ri-message-3-line', color: 'from-amber-500 to-amber-600' },
    { value: '150+', label: 'Disciplinas', icon: 'ri-book-line', color: 'from-green-500 to-green-600' },
    { value: '500+', label: 'Recompensas', icon: 'ri-gift-line', color: 'from-purple-500 to-purple-600' },
  ];

  const features = [
    {
      icon: 'ri-user-search-line',
      title: 'Match Inteligente',
      description: 'Conecte-se com mentores ideais para suas necessidades',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Chat em Tempo Real',
      description: 'Resolva suas dúvidas instantaneamente',
      color: 'from-purple-500 to-pink-500',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Gamificação',
      description: 'Ganhe pontos e badges ao aprender',
      color: 'from-amber-500 to-orange-500',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustentabilidade',
      description: 'Recompensas ecológicas por seu progresso',
      color: 'from-green-500 to-emerald-500',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-blue-50 to-purple-50 pb-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-teal-500 to-blue-500 text-white px-6 pt-8 pb-12 rounded-b-3xl">
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="text-sm opacity-90">Apoio Acadêmico Colaborativo</p>
            <h1 className="text-2xl font-bold mt-1">Tutor Fast</h1>
          </div>
          <button className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full cursor-pointer">
            <i className="ri-star-line text-xl" />
          </button>
        </div>
      </div>

      {/* Logo Card */}
      <div className="px-6 -mt-8">
        <div className="bg-white rounded-3xl shadow-lg p-8 text-center">
          <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-br from-teal-100 to-blue-100 rounded-3xl flex items-center justify-center">
            <i className="ri-graduation-cap-line text-6xl text-teal-600" />
          </div>
          <h2 className="text-3xl font-bold text-teal-600 mb-3">Tutor Fast</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            Conectando alunos em uma rede de aprendizado colaborativo com gamificação e sustentabilidade
          </p>
          <button
            onClick={() => navigate('/mentoria')}
            className="w-full bg-gradient-to-r from-teal-500 to-blue-500 text-white py-4 rounded-full font-semibold flex items-center justify-center gap-2 mb-3 cursor-pointer whitespace-nowrap"
          >
            Começar Agora
            <i className="ri-arrow-right-line text-lg" />
          </button>
          <button
            onClick={() => navigate('/sustentabilidade')}
            className="w-full border-2 border-teal-500 text-teal-600 py-4 rounded-full font-semibold cursor-pointer whitespace-nowrap"
          >
            Ver ODS da ONU
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="px-6 mt-6">
        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${stat.color} text-white rounded-2xl p-5 shadow-md`}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full mb-3">
                <i className={`${stat.icon} text-xl`} />
              </div>
              <div className="text-2xl font-bold mb-1">{stat.value}</div>
              <div className="text-sm opacity-90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div className="px-6 mt-6">
        <h3 className="text-xl font-bold text-gray-800 mb-4">Funcionalidades Principais</h3>
        <div className="space-y-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-5 shadow-md flex items-start gap-4 cursor-pointer hover:shadow-lg transition-shadow"
              onClick={() => {
                if (feature.title.includes('Match')) navigate('/mentoria');
                if (feature.title.includes('Chat')) navigate('/mentoria');
                if (feature.title.includes('Gamificação')) navigate('/gamificacao');
                if (feature.title.includes('Sustentabilidade')) navigate('/sustentabilidade');
              }}
            >
              <div className={`w-14 h-14 flex items-center justify-center bg-gradient-to-br ${feature.color} rounded-2xl flex-shrink-0`}>
                <i className={`${feature.icon} text-2xl text-white`} />
              </div>
              <div className="flex-1">
                <h4 className="font-bold text-gray-800 mb-1">{feature.title}</h4>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
              <i className="ri-arrow-right-s-line text-xl text-gray-400" />
            </div>
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}
